import { Pipe, PipeTransform } from '@angular/core';
import { Profile } from '../models/profile';
import { PROFILE_TYPE } from '../constants';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
const { PAY_NOW_CARRIER_PROFILE_ID } = environment;

@Pipe({
  name: 'nameProfile'
})
export class NameProfilePipe implements PipeTransform {

  constructor(
    private translateService: TranslateService
  ) { }

  transform(value: Profile, args?: any): any {
    return getProfileName(value, this.translateService)
  }
}

export const getProfileName = (profile: Profile, translateService: TranslateService): string => {
  if (!profile) { return ''; }
  
  const { type = '', firstName = '', vatInfo = {} } = profile;
  const { companyName = '' } = vatInfo || {};

  let name = '';

  switch (type) {
    case PROFILE_TYPE.private:
      name = firstName;
      break;
    case PROFILE_TYPE.professional:
    case PROFILE_TYPE.company:
      name = companyName || '';
      break;
    default:
      break;
  }

  return name;
};
